import {
	FETCH_LOCATION_BEGIN,
	FETCH_LOCATION_SUCCESS,
	FETCH_LOCATION_ERROR,
	FETCH_LOCATION_RESET,
	FETCH_CLIENT_LOCATION_BEGIN,
	FETCH_CLIENT_LOCATION_ERROR,
	FETCH_CLIENT_LOCATION_RESET,
	FETCH_CLIENT_LOCATION_SUCCESS,
	POST_LOCATION_BEGIN,
	POST_LOCATION_ERROR,
	POST_LOCATION_RESET,
	POST_LOCATION_SUCCESS,
	POST_LOCATION_TRANSACTION_FILE_BEGIN,
	POST_LOCATION_TRANSACTION_FILE_RESET,
	POST_LOCATION_TRANSACTION_FILE_ERROR,
	POST_LOCATION_TRANSACTION_FILE_SUCCESS,
	DELETE_LOCATION_TRANSACTION_FILE_ERROR,
	DELETE_LOCATION_TRANSACTION_FILE_SUCCESS,
	DELETE_LOCATION_TRANSACTION_FILE_BEGIN,
	DELETE_LOCATION_TRANSACTION_FILE_RESET,
	DELETE_LOCATION_PHOTO_ERROR,
	DELETE_LOCATION_PHOTO_SUCCESS,
	DELETE_LOCATION_PHOTO_BEGIN,
	DELETE_LOCATION_PHOTO_RESET,
	FETCH_LOCATION_VEHICULES_INDISPONIBLES_SUCCESS,
	FETCH_LOCATION_VEHICULES_INDISPONIBLES_BEGIN,
	FETCH_LOCATION_VEHICULES_INDISPONIBLES_ERROR,
	FETCH_LOCATION_VEHICULES_INDISPONIBLES_RESET,
} from "../actions/locationActions"
import * as Addons from "../../utilities/Addons"
import {
	getBaseEntite,
	getBaseVehicule,
	getBaseLocation,
	getBaseLocationClient,
	getBaseVehiculeLocation,
} from "../../utilities/defaultObjects"
import { ENTITE_TYPE_MASTER } from "../../components/dashboard/entite/Entite"
import { normalizePhoto } from "../../utilities/Addons"
import { URL } from "../actions/depannageActions"

const initialState = {
	location: getBaseLocation(),
	client: getBaseLocationClient(),
	entite: getBaseEntite(),
	vehiculeLocation: getBaseVehiculeLocation(),
	vehicule: getBaseVehicule(ENTITE_TYPE_MASTER),
	vehiculesIndisponiblesIds: [],
	conducteurs: [],
	observations: [],
	fetchLocation: {
		loading: false,
		error: false,
	},
	fetchVehiculesIndisponibles: {
		loading: false,
		error: false,
	},
	postLocation: {
		saving: false,
		saved: false,
		error: false,
	},
	postLocationTransaction: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteLocationTransaction: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteLocationPhoto: {
		deleting: false,
		deleted: false,
		error: false,
	},
	fetchClient: {
		loading: false,
		error: false,
	},
}

export default function locationReducer(state = initialState, action) {
	let nextState
	switch (action.type) {
		case DELETE_LOCATION_PHOTO_BEGIN:
			return {
				...state,
				deleteLocationPhoto: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_LOCATION_PHOTO_SUCCESS:
			return {
				...state,
				location: {
					...state.location,
					photosAvant: [
						...action.payload.photos_avant.map((p) =>
							normalizePhoto(p),
						),
					],
					photosApres: [
						...action.payload.photos_apres.map((p) =>
							normalizePhoto(p),
						),
					],
				},
				deleteLocationPhoto: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_LOCATION_PHOTO_RESET:
			return {
				...state,
				deleteLocationPhoto: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_LOCATION_PHOTO_ERROR:
			return {
				...state,
				deleteLocationPhoto: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case DELETE_LOCATION_TRANSACTION_FILE_BEGIN:
			return {
				...state,
				deleteLocationTransaction: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_LOCATION_TRANSACTION_FILE_SUCCESS:
			let deleted_trans_index = state.location.transactions.findIndex(
				(t) => t.id === action.payload.id,
			)
			return {
				...state,
				location: {
					...state.location,
					transactions: [
						...state.location.transactions.slice(
							0,
							deleted_trans_index,
						),
						action.payload,
						...state.location.transactions.slice(
							deleted_trans_index + 1,
						),
					],
				},
				deleteLocationTransaction: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_LOCATION_TRANSACTION_FILE_RESET:
			return {
				...state,
				deleteLocationTransaction: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_LOCATION_TRANSACTION_FILE_ERROR:
			return {
				...state,
				deleteLocationTransaction: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case POST_LOCATION_TRANSACTION_FILE_BEGIN:
			return {
				...state,
				postLocationTransaction: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_LOCATION_TRANSACTION_FILE_RESET:
			return {
				...state,
				postLocationTransaction: {
					saving: false,
					saved: false,
					error: false,
				},
			}

		case POST_LOCATION_TRANSACTION_FILE_ERROR:
			return {
				...state,
				postLocationTransaction: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case POST_LOCATION_TRANSACTION_FILE_SUCCESS:
			let posted_trans_index = state.location.transactions.findIndex(
				(t) => t.id === action.payload.id,
			)
			return {
				...state,
				location: {
					...state.location,
					transactions: [
						...state.location.transactions.slice(
							0,
							posted_trans_index,
						),
						action.payload,
						...state.location.transactions.slice(
							posted_trans_index + 1,
						),
					],
				},
				postAtelierTransactionFile: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case FETCH_LOCATION_BEGIN:
			return {
				...state,
				fetchLocation: {
					loading: true,
					error: false,
				},
			}
		case FETCH_LOCATION_ERROR:
			return {
				...state,
				fetchLocation: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_LOCATION_RESET:
			return {
				...state,
				location: getBaseLocation(),
				client: getBaseLocationClient(),
				vehicule: getBaseVehicule(ENTITE_TYPE_MASTER),
				vehiculeLocation: getBaseVehiculeLocation(),
				conducteurs: [],
				observations: [],
				fetchLocation: {
					loading: false,
					error: false,
				},
			}
		case FETCH_LOCATION_SUCCESS:
			return {
				...state,
				location: formatLocationFromPayload(action.payload.location),
				client: action.payload.client,
				entite: action.payload.entite,
				vehicule: action.payload.vehicule,
				conducteurs: action.payload.conducteurs,
				observations: action.payload.observations,
				// Jordan 30.10 : marqueur « soldée » des fiches liées.
				soldesLiees: action.payload.soldes_liees || null,
				fetchLocation: {
					loading: false,
					error: false,
				},
			}
		case FETCH_LOCATION_VEHICULES_INDISPONIBLES_BEGIN:
			return {
				...state,
				fetchVehiculesIndisponibles: {
					loading: true,
					error: false,
				},
			}
		case FETCH_LOCATION_VEHICULES_INDISPONIBLES_SUCCESS:
			return {
				...state,
				vehiculesIndisponiblesIds: action.payload,
				fetchVehiculesIndisponibles: {
					loading: false,
					error: false,
				},
			}
		case FETCH_LOCATION_VEHICULES_INDISPONIBLES_ERROR:
			return {
				...state,
				fetchVehiculesIndisponibles: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_LOCATION_VEHICULES_INDISPONIBLES_RESET:
			return {
				...state,
				vehiculesIndisponiblesIds: [],
				fetchVehiculesIndisponibles: {
					loading: false,
					error: false,
				},
			}
		case FETCH_CLIENT_LOCATION_BEGIN:
			return {
				...state,
				fetchClient: {
					loading: true,
					error: false,
				},
			}
		case FETCH_CLIENT_LOCATION_SUCCESS:
			return {
				...state,
				client: action.payload.client[0],
				fetchClient: {
					loading: false,
					error: false,
				},
			}
		case FETCH_CLIENT_LOCATION_ERROR:
			return {
				...state,
				fetchClient: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_CLIENT_LOCATION_RESET:
			return {
				...state,
				fetchClient: {
					loading: false,
					error: false,
				},
			}
		case POST_LOCATION_BEGIN:
			return {
				...state,
				postLocation: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_LOCATION_SUCCESS:
			return {
				...state,
				location: action.payload.location,
				entite: action.payload.entite,
				vehicule: action.payload.vehicule,
				conducteurs: action.payload.conducteurs,
				observations: action.payload.observations,
				soldesLiees: action.payload.soldes_liees || null,
				postLocation: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case POST_LOCATION_ERROR:
			return {
				...state,
				postLocation: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case POST_LOCATION_RESET:
			return {
				...state,
				postLocation: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case "UPDATE_LOCATION_DEGATS_AVANT":
			return {
				...state,
				location: {
					...state.location,
					degatsAvant: action.value,
				},
			}
		case "UPDATE_LOCATION_DEGATS_APRES":
			return {
				...state,
				location: {
					...state.location,
					degatsApres: action.value,
				},
			}
		case "UPDATE_VEHICULE_LOCATION":
			return {
				...state,
				vehiculeLocation: action.value,
			}
		case "UPDATE_CLIENT_LOCATION":
			return {
				...state,
				client: action.value,
			}
		case "UPDATE_LOCATION":
			return {
				...state,
				location: action.value,
			}
		case "ADD_CONDUCTEUR":
			return {
				...state,
				conducteurs: [...state.conducteurs, action.value],
			}
		case "REMOVE_CONDUCTEUR":
			return {
				...state,
				conducteurs: [
					...state.conducteurs.slice(0, action.value),
					...state.conducteurs.slice(action.value + 1),
				],
			}
		case "UPDATE_CONDUCTEUR":
			return {
				...state,
				conducteurs: [
					...state.conducteurs.slice(0, action.index),
					action.value,
					...state.conducteurs.slice(action.index + 1),
				],
			}
		case "UPDATE_CONDUCTEURS":
			return {
				...state,
				conducteurs: action.value,
			}
		case "ADD_OBSERVATION":
			return {
				...state,
				observations: [...state.observations, action.value],
			}
		case "REMOVE_OBSERVATION":
			return {
				...state,
				observations: [
					...state.observations.slice(0, action.value),
					...state.observations.slice(action.value + 1),
				],
			}
		case "UPDATE_OBSERVATION":
			return {
				...state,
				observations: [
					...state.observations.slice(0, action.index),
					action.value,
					...state.observations.slice(action.index + 1),
				],
			}
		//////
		case "REMOVE_LOCATION_TRANSACTION":
			nextState = {
				...state,
				location: {
					...state.location,
					transactions: state.location.transactions.filter(
						(transaction) => transaction.id !== action.value,
					),
				},
			}
			return nextState
		case "SET_LOCATION_TRANSACTION":
			const transactionIndex = state.location.transactions.findIndex(
				(transaction) => transaction.id === action.value.id,
			)
			if (transactionIndex !== -1) {
				let tempTransactions = [
					...state.location.transactions.slice(0, transactionIndex),
					action.value,
					...state.location.transactions.slice(transactionIndex + 1),
				]
				nextState = {
					...state,
					location: {
						...state.location,
						transactions: tempTransactions,
					},
				}
				return nextState
			} else {
				nextState = {
					...state,
					location: {
						...state.location,
						transactions: [
							...state.location.transactions,
							action.value,
						],
					},
				}
				return nextState
			}
		case "SET_LOCATION_ENTITE_VEHICULE":
			return {
				...state,
				location: {
					...getBaseLocation(),
					adresse: action.value.adresse,
					entite: action.value.entite.id,
				},
				observations: [],
				conducteurs: [],
				entite: action.value.entite,
			}
		// Fiche location pré-remplie depuis une fiche atelier (couverture
		// location). Rien n'est écrit en base : le lien atelier↔location se fait
		// à la sauvegarde de la location (back : loc_data["atelier"]).
		case "SET_LOCATION_FROM_ATELIER":
			return {
				...state,
				location: {
					...getBaseLocation(),
					...action.value.location,
					entite: action.value.entite.id,
				},
				observations: [],
				conducteurs: [],
				entite: action.value.entite,
			}
		default:
			return state
	}
}

export const formatLocationFromPayload = (location) => {
	return {
		...location,
		photosAvant: location.photosAvant.map(normalizePhoto),
		photosApres: location.photosApres.map(normalizePhoto),
		contrat_0: location.contrat_0 ? `${URL}${location.contrat_0}` : null,
		contrat_1: location.contrat_1 ? `${URL}${location.contrat_1}` : null,
		contrat_2: location.contrat_2 ? `${URL}${location.contrat_2}` : null,
		contrat_3: location.contrat_3 ? `${URL}${location.contrat_3}` : null,
	}
}
